import { FunctionComponent } from 'react';
import { ServiceOrder } from '../../serviceOrders/serviceOrder.types';
import { getServiceNameByType } from '../../serviceOrders/serviceOrderUtils';
import { FormattedMessage } from 'react-intl';
import { Service } from '../../serviceOptions/serviceOption.types';
import { NoValue } from '../../../sharedComponents/NoValue';

export const ServiceDescription: FunctionComponent<{ service: ServiceOrder | Service }> = ({ service }) => (
    <div className="bg-white border rounded padding-15">
        <div className="text-medium text-size-16 margin-bottom-5">
            <span className="rioglyph rioglyph-component-custom padding-right-5" />
            {getServiceNameByType(service.type)}
        </div>
        <div className="display-flex align-items-baseline">
            <div className="text-medium">
                <FormattedMessage id="outboundPortal.serviceOrder.sidebar.serviceDescription" />
                &nbsp;
            </div>
            {service.description ?? <NoValue />}
        </div>
    </div>
);
